import React from 'react';
import {Link} from "@nextui-org/react"; 

const AccessDeniedPage = () => {
  return (
    <div className="min-h-screen flex flex-col justify-center items-center bg-blue-100 px-4">
      <h1 className="text-5xl md:text-7xl font-bold text-blue-600 animate-pulse mb-4">
        Access Denied
      </h1>
      <p className="text-lg md:text-2xl text-blue-500 mb-6 text-center">
        You are not allowed to access this page until you log in.
      </p>
      <Link
        href="/login"
        className="px-6 py-3 bg-blue-500 text-white font-semibold rounded-md hover:bg-blue-600 transition-colors duration-300 animate-fadeIn"
      >
        Go to Login
      </Link>
    </div>
  );
};

export default AccessDeniedPage;

